import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConstantService, ThemeEnum } from '../../services/common/constant.service';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { SharedAuthenticationService } from '../../authentication/shared/shared-authentication.service';

@Component({
  imports: [RouterOutlet, HlmButtonImports],
  selector: 'app-header-layout',
  template: `
    <header class="bg-white">
      <nav class="mx-auto flex max-w-7xl items-center justify-between p-2 lg:px-8">
        <div class="-m-1.5 p-1.5">
          <img src="{{logoUrl}}" alt="Company Logo" class="h-14 w-auto" />
        </div>
        <div>
          <button hlmBtn size="lg" (click)="logout()">Logout</button>
        </div>
      </nav>
    </header>
    <div class="navbar-divider"></div>
    <div class="bs-legacy">
      <router-outlet/>
    </div>
  `,
  styles: `
    .navbar-divider {
      background: linear-gradient(90deg, var(--theme-color-primary) 0%, var(--theme-color-secondary) 100%);
      height: 5px;
      width: 100%;
    }
  `
})
export class HeaderLayout implements OnInit{

  private constantService = inject(ConstantService);
  private sharedService = inject(SharedAuthenticationService);
  
  logoUrl: string = "";

  async ngOnInit() {
    this.logoUrl = this.constantService.getImageFromServer(ThemeEnum.companyLogo) ?? ThemeEnum.companyLogoDefault;
  }

  protected logout(): void {
    this.sharedService.delayedSignout();
  }
}
